import { render } from "./CustomResourceTable.vue?vue&type=template&id=d51b76b4"
import script from "./CustomResourceTable.vue?vue&type=script&lang=js"
export * from "./CustomResourceTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomResourceTable.vue"]])

export default __exports__